import template from './businesses-filter.html';
import BusinessesFilterController from './businesses-filter.controller';
import './businesses-filter.styl';

let businessesFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template,
  controller: BusinessesFilterController,
  controllerAs: 'vm'
};

export default businessesFilterComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/businesses-filter/businesses-filter.component.js
 **/